
import { COLLECTION_PAGE_QUERY, PAGE_TYPE } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({
    $bugsnag,
    error,
    app,
    params: { handle: uid },
    redirect,
    query,
  }) {
    let data;
    try {
      ({ [PAGE_TYPE]: data } = await app.$getPrismicData({
        query: COLLECTION_PAGE_QUERY,
        variables: { uid },
      }));
    } catch (err) {
      $bugsnag.notify(err);

      return error({
        statusCode: 500,
        message: "Oops Something went wrong...",
      });
    }

    if ((data?.slices ?? []).length == 0) {
      return redirect(301, `/collections/${uid}/products`);
    }

    const plpBanner = data.plp_banner_link;
    const bannerConfig = plpBanner?.display_banners
      ? {
          productTileBanners: [
            { image: plpBanner.image_1, image_link: plpBanner.image_1_link },
            { image: plpBanner.image_2, image_link: plpBanner.image_2_link },
          ].filter(({ image }) => image),
          heroBanner: {
            image: plpBanner.image,
            image_link: plpBanner.image_link,
          },
        }
      : null;

    return {
      uid,
      pageType: PAGE_TYPE,
      slices: data.slices,
      title: data.title,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
      context: { collection: data?.collection, bannerConfig },
    };
  },
};
